(() => {
  const init = (scope = document) => {
    scope.querySelectorAll('.product__media__wrapper').forEach(root => {
      if (root.dataset.sbGalleryReady) return;
      const original = root.querySelector('.product__slides');
      const media = [...root.querySelectorAll('.product__media[data-media-id]')];
      if (!original || !media.length) return;
      root.dataset.sbGalleryReady = 'true';
      const product = root.closest('[data-product-handle]');
      const title = product?.querySelector('h1')?.textContent.trim() || document.title;
      const gallery = document.createElement('div');
      gallery.className = 'sb-standard-gallery';
      gallery.setAttribute('aria-label', title);
      const stage = document.createElement('div');
      stage.className = 'sb-standard-stage';
      const thumbs = document.createElement('div');
      thumbs.className = 'sb-standard-thumbs';
      thumbs.setAttribute('aria-label', title);
      const frames = [];
      const buttons = [];
      const imageItems = [];
      let selected = 0;
      let dialogIndex = 0;
      const makeButton = (label, text, className) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = className;
        button.setAttribute('aria-label', label);
        button.textContent = text;
        return button;
      };
      const labels = window.sbGalleryLabels || {};
      const label = (key, fallback) => labels[key] || fallback;
      const dialog = document.createElement('dialog');
      dialog.className = 'sb-standard-viewer';
      dialog.setAttribute('aria-label', title);
      const close = makeButton(label('close', 'Close'), '×', 'sb-standard-viewer-close');
      const enlarged = document.createElement('img');
      enlarged.alt = title;
      const counter = document.createElement('span');
      counter.className = 'sb-standard-viewer-count';
      counter.setAttribute('aria-live', 'polite');
      const dialogPrev = makeButton(label('previous', 'Previous'), '‹', 'sb-standard-viewer-prev');
      const dialogNext = makeButton(label('next', 'Next'), '›', 'sb-standard-viewer-next');
      dialog.append(close, dialogPrev, enlarged, dialogNext, counter);
      document.body.append(dialog);
      const showDialog = index => {
        dialogIndex = (index + imageItems.length) % imageItems.length;
        const item = imageItems[dialogIndex];
        enlarged.src = item.full;
        enlarged.alt = item.alt;
        counter.textContent = `${dialogIndex + 1} / ${imageItems.length}`;
        dialogPrev.hidden = dialogNext.hidden = imageItems.length < 2;
      };
      const open = index => {
        showDialog(index);
        if (!dialog.open) dialog.showModal();
        document.documentElement.classList.add('sb-standard-viewer-open');
        close.focus();
      };
      close.addEventListener('click', () => dialog.close());
      dialogPrev.addEventListener('click', () => showDialog(dialogIndex - 1));
      dialogNext.addEventListener('click', () => showDialog(dialogIndex + 1));
      dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
      dialog.addEventListener('close', () => {
        document.documentElement.classList.remove('sb-standard-viewer-open');
        frames[selected]?.querySelector('button')?.focus({preventScroll: true});
      });
      dialog.addEventListener('keydown', event => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          showDialog(dialogIndex + (event.key === 'ArrowRight' ? 1 : -1));
        }
      });
      media.forEach((item, index) => {
        const frame = document.createElement('div');
        frame.className = 'sb-standard-slide';
        frame.dataset.mediaId = item.dataset.mediaId;
        frame.hidden = index !== 0;
        const sourceImage = item.querySelector('img[data-product-image]');
        const oldThumb = root.querySelector(`[data-media-select="${item.dataset.mediaId}"] img`);
        const thumb = makeButton(`${label('view', 'View image')} ${index + 1}`, '', 'sb-standard-thumb');
        thumb.setAttribute('aria-pressed', String(index === 0));
        const thumbImage = document.createElement('img');
        const thumbnailSource = oldThumb?.dataset.src || oldThumb?.getAttribute('src') || sourceImage?.getAttribute('src') || sourceImage?.dataset.src;
        if (thumbnailSource) thumbImage.src = thumbnailSource;
        thumbImage.alt = '';
        thumbImage.loading = 'lazy';
        thumb.append(thumbImage);
        if (sourceImage) {
          const source = sourceImage.dataset.src || sourceImage.currentSrc || sourceImage.getAttribute('src');
          const url = new URL(source, location.href);
          url.pathname = url.pathname.replace(/_\d+x\d*(?=\.[^.]+$)/, '');
          if (url.protocol === 'http:') url.protocol = 'https:';
          url.searchParams.set('width', '2200');
          const imageIndex = imageItems.length;
          imageItems.push({full: url.href, alt: sourceImage.alt || title});
          const zoom = makeButton(label('enlarge', 'Enlarge image'), '', 'sb-standard-enlarge');
          const image = document.createElement('img');
          image.src = source;
          image.alt = sourceImage.alt || title;
          image.width = Number(sourceImage.getAttribute('width')) || 1200;
          image.height = Number(sourceImage.getAttribute('height')) || 1200;
          image.loading = index === 0 ? 'eager' : 'lazy';
          image.decoding = 'async';
          zoom.append(image);
          zoom.addEventListener('click', () => open(imageIndex));
          frame.append(zoom);
        } else {
          const content = item.querySelector('iframe,video,model-viewer');
          if (content) {
            const copy = content.cloneNode(true);
            if (copy.tagName === 'IFRAME') {
              copy.dataset.sbSource = copy.getAttribute('src') || copy.dataset.src || '';
              copy.removeAttribute('src');
              copy.removeAttribute('data-src');
              copy.loading = 'lazy';
              copy.title = content.title || title;
            }
            frame.append(copy);
            const videoMark = document.createElement('span');
            videoMark.className = 'sb-standard-video-mark';
            videoMark.textContent = '▶';
            videoMark.setAttribute('aria-hidden', 'true');
            thumb.append(videoMark);
          }
        }
        frames.push(frame);
        buttons.push(thumb);
        stage.append(frame);
        thumbs.append(thumb);
      });
      const show = index => {
        selected = (index + frames.length) % frames.length;
        frames.forEach((frame, i) => {
          frame.hidden = i !== selected;
          frame.querySelectorAll('video').forEach(video => { if (i !== selected) video.pause(); });
          frame.querySelectorAll('iframe').forEach(iframe => {
            if (i === selected && !iframe.getAttribute('src') && iframe.dataset.sbSource) iframe.src = iframe.dataset.sbSource;
            else if (i !== selected && iframe.getAttribute('src')) iframe.removeAttribute('src');
          });
          buttons[i].setAttribute('aria-pressed', String(i === selected));
        });
      };
      buttons.forEach((button, index) => button.addEventListener('click', () => show(index)));
      if (frames.length > 1) {
        const prev = makeButton(label('previous', 'Previous'), '‹', 'sb-standard-prev');
        const next = makeButton(label('next', 'Next'), '›', 'sb-standard-next');
        prev.addEventListener('click', () => show(selected - 1));
        next.addEventListener('click', () => show(selected + 1));
        stage.append(prev, next);
      }
      gallery.append(stage);
      if (frames.length > 1) gallery.append(thumbs);
      root.prepend(gallery);
      product?.addEventListener('theme:variant:change', event => {
        const variant = event.detail?.variant;
        const id = variant?.featured_media?.id || variant?.featured_image?.id;
        const match = media.findIndex(item => String(item.dataset.mediaId) === String(id));
        if (match >= 0) show(match);
      });
      show(0);
    });
    scope.querySelectorAll('[data-pf-type="MediaMain3"],[data-pf-type="MediaMain2"],[data-sb-type="MediaMain3"]').forEach(root => {
      if (root.dataset.sbSharedViewer) return;
      let images = [...root.querySelectorAll('img')].filter(img => !img.closest('[data-media-type="video"],[data-media-type="external_video"]'));
      if (!images.length) return;
      root.dataset.sbSharedViewer = 'true';
      const labels = window.sbGalleryLabels || {};
      const dialog = document.createElement('dialog');
      dialog.className = 'sb-standard-viewer';
      dialog.setAttribute('aria-label', document.querySelector('h1')?.textContent.trim() || document.title);
      const picture = document.createElement('img');
      const counter = document.createElement('span');
      counter.className = 'sb-standard-viewer-count';
      counter.setAttribute('aria-live', 'polite');
      const control = (label, text, className) => {
        const button = document.createElement('button');
        button.type = 'button';button.className = className;
        button.setAttribute('aria-label', label);button.textContent = text;
        return button;
      };
      const close = control(labels.close || 'Close', '×', 'sb-standard-viewer-close');
      const prev = control(labels.previous || 'Previous', '‹', 'sb-standard-viewer-prev');
      const next = control(labels.next || 'Next', '›', 'sb-standard-viewer-next');
      dialog.append(close, prev, picture, next, counter);
      document.body.append(dialog);
      let index = 0, opener;
      const show = value => {
        index = (value + images.length) % images.length;
        const image = images[index];
        const url = new URL(image.currentSrc || image.getAttribute('src') || image.dataset.src, location.href);
        url.pathname = url.pathname.replace(/_\d+x\d*(?=\.[^.]+$)/, '');
        url.searchParams.set('width', '2400');
        picture.src = url.href;picture.alt = image.alt;
        counter.textContent = `${index + 1} / ${images.length}`;
        prev.hidden = next.hidden = images.length < 2;
      };
      const open = image => {
        opener = image;show(images.indexOf(image));dialog.showModal();
        document.documentElement.classList.add('sb-standard-viewer-open');close.focus();
      };
      const refreshImages = () => {
        images = [...root.querySelectorAll('img')].filter(img => !img.closest('[data-media-type="video"],[data-media-type="external_video"]'));
        images.forEach(image => {
          image.tabIndex = 0;image.setAttribute('role', 'button');
          image.setAttribute('aria-label', `${labels.enlarge || 'Enlarge image'}: ${image.alt}`);
          image.style.cursor = 'zoom-in';
        });
      };
      refreshImages();
      new MutationObserver(refreshImages).observe(root, {childList:true, subtree:true});
      root.addEventListener('click', event => {
        const image = event.target.closest('img');
        if (!images.includes(image)) return;
        event.preventDefault();event.stopImmediatePropagation();open(image);
      }, true);
      root.addEventListener('keydown', event => {
        if (!images.includes(event.target) || !['Enter',' '].includes(event.key)) return;
        event.preventDefault();event.stopImmediatePropagation();open(event.target);
      }, true);
      close.addEventListener('click', () => dialog.close());
      prev.addEventListener('click', () => show(index - 1));
      next.addEventListener('click', () => show(index + 1));
      dialog.addEventListener('keydown', event => {
        if (['ArrowLeft','ArrowRight'].includes(event.key)) {
          event.preventDefault();show(index + (event.key === 'ArrowRight' ? 1 : -1));
        }
      });
      dialog.addEventListener('click', event => {if (event.target === dialog) dialog.close();});
      dialog.addEventListener('close', () => {
        document.documentElement.classList.remove('sb-standard-viewer-open');
        opener?.focus({preventScroll:true});
      });
    });
    const header = document.querySelector('.header__wrapper');
    const setOffset = () => document.documentElement.style.setProperty('--sb-product-sticky-offset', `${Math.ceil(header?.getBoundingClientRect().height || 80) + 16}px`);
    setOffset();
    if (header && !header.dataset.sbGalleryOffset) {
      header.dataset.sbGalleryOffset = 'true';
      new ResizeObserver(setOffset).observe(header);
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), {once:true});
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
